import { logger } from '@inboundx/shared/platform';
import posthog from 'posthog-js';

/**
 * Self-serve onboarding funnel (IX-3897).
 *
 * One PostHog event, `rw_onboarding_step`, carries a `step` property for every
 * gate from the pre-backoffice wizard through to the widget going live. The
 * funnel insight in PostHog is built from this single event, filtered per step.
 * Steps are emitted at their completion point, in this order:
 *   wizard_website → wizard_company → wizard_language → domain_claimed
 *   → starter_reviewed → cta_reviewed → tested → installed
 * (`installed` = Rose live on the client's site). Brand review auto-advances, so
 * it is deliberately not a funnel step.
 */
export type OnboardingFunnelStep =
    | 'wizard_website'
    | 'wizard_company'
    | 'wizard_language'
    | 'domain_claimed'
    | 'starter_reviewed'
    | 'cta_reviewed'
    | 'tested'
    | 'installed';

export function trackOnboardingStep(step: OnboardingFunnelStep, domain?: string): void {
    try {
        posthog.capture('rw_onboarding_step', domain ? { step, domain } : { step });
    } catch (error) {
        // Analytics is best-effort; never break the onboarding flow on a capture.
        logger.error('onboarding funnel capture failed', error);
    }
}
